import Helper from "./Helper";
import { CountUp } from "../../node_modules/countup.js";

class CountUpNumbers {
  constructor(config = {}) {
    const {
      numbersSelector,
      classIn,
      classOut,
      langArray,
      decimalArray,
      thousandSepArray,
    } = config;

    this.numbers = document.querySelectorAll(numbersSelector);
    this.numbersArray = Array.prototype.slice.call(this.numbers);
    this.classIn = classIn;
    this.classOut = classOut;

    this.decimal = "";
    this.separator = "";

    // Handle multilingual separators and decimals
    langArray.forEach((lang, index) => {
      if (document.documentElement.lang == lang) {
        this.decimal = decimalArray[index];
        this.separator = thousandSepArray[index];
      }
    });

    // Store numbers for animation
    this.numberObj = [];
    this.numberObj = this.addNumbersToArray(this.numberObj, this.numbersArray);

    this.options = {
      startVal: 0,
      decimalPlaces: 0,
      duration: 4,
      useEasing: true,
      decimal: this.decimal,
      separator: " ", // Ensure spaces remain
    };

    if (this.numbers && this.numbers.length !== 0) {
      this.addId(this.numbersArray);
      this.registerScroll();
      this.bindEvents();
    }
  }

  bindEvents() {
    this.numbersArray.forEach((item) => {
      if (Helper.isInViewport(item)) {
        Helper.addClass(item, this.classIn);
        Helper.removeClass(item, this.classOut);
      } else {
        Helper.removeClass(item, this.classIn);
        Helper.addClass(item, this.classOut);
      }
    });
  }

  registerScroll() {
    window.addEventListener("scroll", () => {
      this.numbersArray.forEach((item, index) => {
        this.addClassOnScroll(item);
        if (Helper.hasClass(item, this.classIn)) {
          if (!Helper.hasClass(item, "counting")) {
            Helper.addClass(item, "counting");
            this.options.decimalPlaces = this.getDecimalPlaces(item);
            const countUp = new CountUp(
              item.id,
              this.numberObj[index],
              this.options
            );
            if (!countUp.error) {
              countUp.start();
            } else {
              console.error(countUp.error);
            }
          }
        }
      });
    });
  }

  addClassOnScroll(element) {
    if (Helper.isInViewport(element)) {
      Helper.addClass(element, this.classIn);
      Helper.removeClass(element, this.classOut);
    } else {
      Helper.addClass(element, this.classOut);
      Helper.removeClass(element, this.classIn);
    }
  }

  getDecimalPlaces(item) {
    const text = item.innerText.trim().replace(/\s/g, ""); // Remove spaces for parsing
    const split = text.split(this.decimal);
    const decimals = split[1];
    return decimals ? decimals.length : 0;
  }

  addNumbersToArray(obj, arr) {
    arr.forEach((item) => {
      let numText = item.innerText.trim().replace(/\s/g, ""); // Remove spaces for parsing
      let numberWithDecimal = numText.replace(this.decimal, ".");
      let parsedNumber = Number(numberWithDecimal);
      obj.push(parsedNumber);
    });
    return obj;
  }

  addId(arr) {
    arr.forEach((item, index) => {
      item.id = "numb" + index;
    });
  }
}

export default CountUpNumbers;
